import * as yup from 'yup';

export const signUpValidationSchema = yup.object().shape({
  fullName: yup.string().required('Your name is required'),
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Email address is required'),
  password: yup
    .string()
    .min(8, ({ min }) => `Password must be at least ${min} characters`)
    .matches(
      /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Password must contain at least:\n - 8 characters\n - 1 uppercase letter\n - 1 number\n - 1 special case character',
    )
    .required('Password is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
  userType: yup.string().required('Please choose your role'),
  agreedToTerms: yup
    .boolean()
    .oneOf([true], 'Please review and agree to our terms and conditions'),
});
